"use strict";

/**
* Реквизит типа «Выбор из справочника» и «Множественный выбор».
*
* @class WebAccess.components.wrappers.form.requisites.Reference
* @extends WebAccess.components.wrappers.form.requisites.BaseObjectSelectRequisite
* @property {string} name Имя реквизита
* @param {string} requisiteName Имя реквизита
* @param {obbject} data Данные для инициализации реквизита
* @since 5.0.0.7100
*/
(function (global) {

  var Reference = global.WA.CMP.wrappers.form.requisites.BaseObjectSelectRequisite.extend({
    className: "Reference",

    /**
    * Установить фильтрацию по реквизитам справочника.
    *
    * @method WebAccess.components.wrappers.form.requisites.Reference#setFilter
    * @return {WebAccess.components.wrappers.form.requisites.Reference} Текущий объект реквизита – Reference.
    * @since 5.0.0.7100
    */
    setFilter: function (filter, opt_refCode) {
      if (this.controls.length === 0) return;
      for (var i = 0; i < this.controls.length; i++) {
        var jControl = this.controls[i];
        if (!opt_refCode) {
          jControl.data('filter', filter);
        } else {
          jControl.data('ReferenceSelectInstance').refcodes[opt_refCode]['Filter'] = filter;
        }
      };
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//


    /**
    * Получает выражение фильтрации реквизита.
    *
    * @method WebAccess.components.wrappers.form.requisites.Reference#getFilter
    * @since 5.4.0.1013
    * @return {string} Выражение фильтрации.
    */
    getFilter: function (referenceCode) {
      if (this.controls.length === 0) return null;

      var filter = null;
      for (var i = 0; i < this.controls.length; i++) {
        var jControl = this.controls[i];
        var refSelect = jControl.data('ReferenceSelectInstance');
        if (referenceCode && refSelect && refSelect.refcodes[referenceCode]) {
          filter = refSelect.refcodes[referenceCode]['Filter'];
        }
        return filter || jControl.data('filter');
      }
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Получить имена справочников для выборки.
    *
    * @method WebAccess.components.wrappers.form.requisites.Reference#getReferences
    * @since 5.0.0.7200
    * @return {object} Имена справочников для выборки.
    */
    getReferences: function () {
      var jControl;
      if (this.controls.length === 0) return this;
      for (var i = 0; i < this.controls.length; i++) {
        jControl = this.controls[i];
        return jControl.data('ReferenceSelectInstance').refcodes;
      };
    },

    /**
    * Установить выборку из указанных справочников.
    *
    * @method WebAccess.components.wrappers.form.requisites.Reference#setReferences
    * @param {object} references Информация о справочниках. Формат описания выборки:
    * {"ОРГ":{"Caption": "организации",...},"РАБ":{..}}}
    * @return {WebAccess.components.wrappers.form.requisites.Reference} Текущий объект реквизита – Reference.
    * @since 5.0.0.7100
    */
    setReferences: function (references) {
      var jControl;
      if (this.controls.length === 0) return this;
      for (var i = 0; i < this.controls.length; i++) {
        jControl = this.controls[i];
        jControl.data('ReferenceSelectInstance').setReferences(references);
      };
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Добавить новый справочник к текущему списку справочников для выборки.
    *
    * @function WebAccess.components.wrappers.form.requisites.Reference#addReferences
    * @param {object} references Информация о справочниках. Формат описания выборки:
    * {"ОРГ":{"Caption": "организации",...},"РАБ":{..}}}
    * @return {WebAccess.components.wrappers.form.requisites.Reference} Текущий объект реквизита – Reference.
    * @since 5.0.0.7100
    */
    addReferences: function (references) {
      if (this.controls.length === 0) return this;
      for (var i = 0; i < this.controls.length; i++) {
        var jControl = this.controls[i];
        jControl.data('ReferenceSelectInstance').addReferences(references);
      };
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Установить значение отображаемых и неотображаемых реквизитов.
    * Формат записи метода: [{groupcode:'код справочника', id:'ид записи', name:'наименование'}, ...].
    *
    * @function WebAccess.components.wrappers.form.requisites.Reference#setValues
    * @param {object} newValues Новые значения множественного выбора
    * @param {boolean} needTriggerResult Вызвать триггер для события типа change
    * @return {WebAccess.components.wrappers.form.requisites.Reference} Текущий объект реквизита – Reference.
    * @since 5.0.0.7100
    */
    setValues: function (newValues, needTriggerResult) {
      var me = this;
      if (me.controls.length === 0) return me; //TODO Сделать установку скрытых полей множественного выбора.
      me._setControlsValues(newValues, needTriggerResult);

      me._updateNewValues(newValues).done(function (updatedNewValues) {
        me._setControlsValues(updatedNewValues, false);
      });

      me.touch();
      return me;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Установить значение контролов.
    *
    * @function WebAccess.components.wrappers.form.requisites.Reference#_setControlsValues
    * @private
    * @param {object} newValues Новые значения множественного выбора
    * @param {boolean} needTriggerResult Вызвать триггер для события типа change
    * @since 5.0.0.9107
    */
    _setControlsValues: function (newValues, needTriggerResult) {
      var me = this;
      for (var i = 0; i < me.controls.length; i++) {
        var jControl = me.controls[i];
        jControl.data('ReferenceSelectInstance').setValues(newValues, needTriggerResult);
      };
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Обновить значения устанавливаемых значений.
    *
    * @function WebAccess.components.wrappers.form.requisites.Reference#_updateNewValues
    * @param {object} newValues Обновляемые значения.
    * @return {Array} Обновленный список значений с заполненными свойствами наименования и справочника.
    * @since 5.5.0.9000
    */
    _updateNewValues: function (newValues) {
      var d = $.Deferred();

      if (newValues.length) {
        // Получить список новых значений, у которых не указаны отображаемые значения
        var withoutDisplayValues = newValues.filter(function (item) {
          return !item.name && item.id;
        });

        if (withoutDisplayValues.length) {
          var ids = [];
          withoutDisplayValues.forEach(function (item) {
            ids.push(item.id);
          });

          // Получим наименования записей справочника
          WA.SRV.reference.getReferenceRecordsNames(ids).done(function (res) {
            // Пройтись по всем записям справочника
            newValues.forEach(function (item) {
              if (!item.name && res[item.id]) {
                item.name = res[item.id].name;
              }
            });

            d.resolve(newValues);
          });
        } else {
          d.resolve(newValues);
        }
      } else {
        d.resolve(newValues);
      }


      return d.promise();
    },

    /**
    * Получает значения реквизита.
    * Формат результата метода: [{groupcode:'код справочника', id:'ид записи', name:'наименование'}, ...].
    *
    * @function WebAccess.components.wrappers.form.requisites.Reference#getValues
    * @return {Array<Object>} Массив объектов значений реквизита – currentValues.
    * @since 5.4.0.1012
    */
    getValues: function () {
      if (this.controls.length === 0) return this; //TODO Сделать установку скрытых полей множественного выбора.
      for (var i = 0; i < this.controls.length; i++) {
        var jControl = this.controls[i];
        return jControl.data('ReferenceSelectInstance').getValues();
      };
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Добавляет новые значения отображаемых и неотображаемых реквизитов к уже существующим.
    * Формат записи метода: [{groupcode:'код справочника', id:'ид записи', name:'наименование'}, ...].
    *
    * @function WebAccess.components.wrappers.form.requisites.Reference#addValues
    * @param {object} newValues Новые значения множественного выбора
    * @param {boolean} needTriggerResult Вызвать триггер для события типа change
    * @return {WebAccess.components.wrappers.form.requisites.Reference} Текущий объект реквизита – Reference.
    * @since 5.4.0.1012
    */
    addValues: function (newValues, needTriggerResult) {
      var me = this;
      var currentValues = me.getValues();
      me._addValues(currentValues, newValues, needTriggerResult);

      me._updateNewValues(newValues).done(function (updatedNewValues) {
        me._addValues(currentValues, updatedNewValues, false);
      });

      return me;
    },

    /**
    * Добавить новые значения к реквизиту.
    *
    * @function WebAccess.components.wrappers.form.requisites.Reference#_addValues
    * @private
    * @param {object} currentValues -  значение реквизита, к которому добавляются новые.
    * @param {object} newValues Новые значения множественного выбора
    * @param {boolean} needTriggerResult Вызвать триггер для события типа change
    * @return {WebAccess.components.wrappers.form.requisites.Reference} Текущий объект реквизита – Reference.
    * @since 5.5.0.9107
    */
    _addValues: function (currentValues, newValues, needTriggerResult) {
      var me = this;
      var allValues = currentValues.concat(newValues.filter(function (newItem) {
        var unique = true;
        currentValues.forEach(function (currentItem) {
          if (currentItem.id == newItem.id) {
            unique = false;
            return false;
          }
        });
        return unique;
      }));
      me.setValues(allValues, needTriggerResult);
      return me;
    },

    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Указать справочник, выбор из которого будет выполняться в первую очередь.
    *
    * @method WebAccess.components.wrappers.form.requisites.Reference#setMainReference
    * @param {string} referenceName Справочник, выбор из которого будет выполняться в первую очередь
    * @return {WebAccess.components.wrappers.form.requisites.Reference} Объект типа Reference.
    * @since 5.0.0.7200
    */
    setMainReference: function (referenceName) {
      if (this.controls.length === 0) return this;
      for (var i = 0; i < this.controls.length; i++) {
        var jControl = this.controls[i];
        jControl.data('ReferenceSelectInstance').mainReferenceCode = referenceName;
      };
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Очистить параметры выбора из справочников.
    *
    * @method WebAccess.components.wrappers.form.requisites.Reference#clearReferences
    * @return {WebAccess.components.wrappers.form.requisites.Reference} Объект типа Reference.
    * @since 5.0.0.7200
    */
    clearReferences: function () {
      this.setReferences({});
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Добавляет справочник для выборки, из которого доступны последние и избранные объекты.
    *
    * @method WebAccess.components.wrappers.form.requisites.Reference#addLastObjectsPseudoReference
    * @param {LAST_REFERENCES} lastReferences Справочники, из которых будет выполняться выбор
    * @return {WebAccess.components.wrappers.form.requisites.Reference} Объект типа Reference.
    * @since 5.0.0.7200
    */
    addLastObjectsPseudoReference: function (lastReferences) {
      var oldRefs = this.getReferences();

      var newRefs = $.extend({
        'ROUTELASTOBJS': { 'Caption': L('ROUTE_LAST_OBJECTS_PSEUDO_REFERENCE_CAPTION'), 'NeedShowHint': true, 'DisableSpecialProcessing': false, 'Filter': lastReferences }
      }, oldRefs);

      this.setReferences(newRefs);
      return this;
    },

    /**
    * Удалить из списка выборки справочник, из которого доступны последние и избранные объекты.
    *
    * @method WebAccess.components.wrappers.form.requisites.Reference#removeLastObjectsPseudoReference
    * @param {LAST_REFERENCES} LastReferences Справочники, из которых будет выполняться выбор
    * @return {WebAccess.components.wrappers.form.requisites.Reference} Объект типа Reference.
    * @since 5.0.0.7200
    */
    removeLastObjectsPseudoReference: function () {
      var oldRefs = this.getReferences();
      delete oldRefs['ROUTELASTOBJS'];
      this.setReferences(oldRefs);
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Привязывает вызов справочника в модальном окне к клику на иконке в поле ввода.
    *
    * @method WebAccess.components.wrappers.form.requisites.Reference#bindReferenceGridDialog
    * @since 5.4.0.1012
    * @return {WebAccess.components.wrappers.form.requisites.Reference} Текущий объект реквизита – Reference
    */
    bindReferenceGridDialog: function () {
      var me = this;
      for (var i = 0; i < me.controls.length; i++) {
        var jControl = me.controls[i];
        var jContainer = jControl.parents('.reference_requisite');
        var jReqIcon = jContainer.find('.Req_Icon');
        jReqIcon.unbind('click touchstart').bind('click touchstart', function (e) {
          e.stopPropagation();
          var referenceCode = '';
          // Получаем первый код справочника
          for (var value in me.getReferences()) {
            referenceCode = value;
            break;
          }
          var mode = me.isDisabled() ? REFERENCE_MODAL_MODE.VIEW :
            (me.isMultiselect() ? REFERENCE_MODAL_MODE.MULTI : REFERENCE_MODAL_MODE.SINGLE);
          WebAccess.components.dialogs.ReferenceGridDialog.createAndShow({
            referenceName: referenceCode,
            mode: mode,
            filterExpression: me.getFilter(referenceCode),
            filterQuery: jControl.val(),
            queryContext: me.queryContext(),
            leaderSelectedId: me.leaderSelectedId()
          }).selectionDone(function (result) {
            if (mode == REFERENCE_MODAL_MODE.MULTI) {
              var valuesToBeSet = result.map(function (entry) {
                return {
                  groupcode: referenceCode,
                  id: entry.id,
                  name: entry.name
                }
              });
              me.addValues(valuesToBeSet);
            } else if (mode == REFERENCE_MODAL_MODE.SINGLE) {
              me.setValue(result[0].id, result[0].name, true, result[0].leaderRequisiteValues);
            }
          });
        });
      }
      return me;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Возвращает признак возможности множественного выбора.
    *
    * @method WebAccess.components.wrappers.form.requisites.Reference#isMultiselect
    * @since 5.4.0.1013
    * @return {boolean} True - если реквизит поддерживает множественный выбор, иначе - False.
    */
    isMultiselect: function () {
      if (this.controls.length === 0) return false;
      for (var i = 0; i < this.controls.length; i++) {
        return this.controls[i].data('ReferenceSelectInstance').multiselect;
      }
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//


    /**
    * Возвращает контекст выборки.
    *
    * @method WebAccess.components.wrappers.form.requisites.Reference#queryContext
    * @since 5.5.0.1000
    * @return {dict} Контекст выборки.
    */
    queryContext: function () {
      if (this.controls.length === 0) return null;
      for (var i = 0; i < this.controls.length; i++) {
        return this.controls[i].data('ReferenceSelectInstance').queryContext;
      }
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//


    /**
    * Возвращает список ведущих реквизитов.
    *
    * @method WebAccess.components.wrappers.form.requisites.Reference#leaderSelectedId
    * @since 5.5.0.1000
    * @return {string} Список ведущих реквизитов.
    */
    leaderSelectedId: function () {
      if (this.controls.length === 0) return null;
      for (var i = 0; i < this.controls.length; i++) {
        return this.controls[i].data('ReferenceSelectInstance').extraParams.LeadSelID();
      }
    },

    /**
    * Установить значение отображаемых и неотображаемых реквизитов.
    *
    * @method WebAccess.components.wrappers.form.requisites.Reference#setValue
    * @param value {string} Устанавливаемое значение
    * @param [opt_displayValue] {string} Отображаемое значение
    * @param [opt_needTriggerResult] {string} Вызвать триггер для события типа change
    * @return {WebAccess.components.wrappers.form.requisites.Reference} Текущий объект реквизита – Reference.
    * @since 5.5.0.9000
    */
    setValue: function (value, opt_displayValue, opt_needTriggerResult, opt_leadRequisiteValues) {
      var me = this;
      me._super(value, opt_displayValue, opt_needTriggerResult, opt_leadRequisiteValues);

      if (!opt_displayValue && !me.hasCalculation) {
        if (value) {
          var baseSetValue = me._super;

          var references = me.getReferences();
          var referenceName = Object.keys(references)[0];
          me._updateNewValues([{ groupcode: referenceName, id: value, name: '' }]).done(function (updatedNewValues) {
            baseSetValue.apply(me, [value, updatedNewValues[0].name, false, false]);
          });
        }
      }

      return me;
    }

  });
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  global.WA.CMP.wrappers.form.requisites.Reference = Reference;
})(window);